import { FC } from 'react';
import { Link, LinkProps, withRouter } from 'react-router-dom';
import { RouteCoreComponentPropsType } from 'core/components/layout/Routing';

const LangLink: FC<LinkProps & RouteCoreComponentPropsType> = ({
  to,
  match,
  history,
  location,
  children,
  staticContext,
  href,
  ...props
}) => {
  const langPath = match.params.lang ? `/${match.params.lang}` : '';
  return (
    <Link to={`${langPath}${to}`} {...props}>
      {children}
    </Link>
  );
};

export default withRouter(LangLink);
